import { footColumns, mottoList } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-50">
      <div className="mx-auto max-w-6xl px-4 pt-12 md:px-6 md:pt-14">
        <div className="grid gap-10 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
          {/* brand + motto */}
          <div>
            <a href="#cover" className="inline-flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-600 text-lg font-black">
                <i className="ri-eye-line" />
              </div>
              <span className="font-heading text-xl font-black tracking-tight">
                最全<span className="text-accent-400">黑料</span>
              </span>
            </a>
            <p className="mt-3 max-w-xs text-[13px] leading-relaxed text-background-200/80">
              内幕真相、背后揭秘与始末时间线梳理，证据先行，把一件事的来龙去脉讲清楚。
            </p>
            <ul className="mt-4 space-y-1.5">
              {mottoList.map((m) => (
                <li key={m} className="flex items-start gap-2 text-[12px] text-background-100/60">
                  <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-secondary-500" />
                  {m}
                </li>
              ))}
            </ul>
          </div>

          {/* link columns */}
          {footColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-xs font-bold tracking-[0.18em] text-background-50/90">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#cover"
                      className="cursor-pointer text-[13px] text-background-200/75 transition-colors hover:text-accent-300"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* disclaimer */}
        <div className="mt-10 rounded-lg border border-background-800/80 bg-background-800/60 px-4 py-3.5 text-[12px] leading-relaxed text-background-200/70">
          内容说明：本站所载信息以公开材料与多方说法整理为主，用于信息梳理与观点交流，不构成对任何主体的事实认定或法律结论。文中标注「待核实」内容仍在补充证据，请理性看待。
        </div>

        {/* bottom bar */}
        <div className="mt-6 flex flex-col items-center justify-between gap-4 border-t border-background-800 py-6 sm:flex-row">
          <p className="text-[12px] text-background-200/60">
            © 2026 最全黑料 · 保留所有权利 · 证据先行，结论文后
          </p>
          <div className="flex items-center gap-2.5">
            {["ri-wechat-2-line", "ri-weibo-line", "ri-rss-line", "ri-mail-line"].map((ic) => (
              <a
                key={ic}
                href="#cover"
                aria-label="社交链接"
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-background-800 text-background-200/70 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className={ic} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}